import imageCreek from "../../common/assets/bgCreek.png";
import imageNuevamente from "../../common/assets/bgNuevamente.png";
import imageHangover from "../../common/assets/bgHangover.png";
import imageLeparc from "../../common/assets/bgLeparc.png";
import imageKeops from "../../common/assets/bgKeops.png";
import imageQuickpass from "../../common/assets/bgQuickpass.png";
import imageRosario from "../../common/assets/bgRosario.png";
import imageWabi from "../../common/assets/bgWabi.png";
import imageRoof from "../../common/assets/bgRoof.png";
import imageEventclub from "../../common/assets/bgEventclub.png";
import imageFruta from "../../common/assets/bgFruta.png";
import imageBarto from "../../common/assets/bgBarto.png";
import imageCircus from "../../common/assets/bgCircus.png";
import imageFendy from "../../common/assets/bgFendy.png";
import imageCruz from "../../common/assets/bgCruz.png";


let bgLoginImage = null;
const tenantId = process.env.REACT_APP_PRODUCT_ID;


if (tenantId == "creek") {
    bgLoginImage = imageCreek;
}else if (tenantId == "nuevamente") {
    bgLoginImage = imageNuevamente;
}else if (tenantId == "leparc") {
    bgLoginImage = imageLeparc;
}else if (tenantId == "hangover") {
    bgLoginImage = imageHangover;
}else if (tenantId == "keops") {
    bgLoginImage = imageKeops;
}else if (tenantId == "quickpass") {
    bgLoginImage = imageQuickpass;
}else if (tenantId == "rosario") {
    bgLoginImage = imageRosario;
}else if (tenantId == "wabi") {
    bgLoginImage = imageWabi;
}else if (tenantId == "roof") {
    bgLoginImage = imageRoof;
}else if (tenantId == "evtclub") {
    bgLoginImage = imageEventclub;
}else if (tenantId == "fruta") {
    bgLoginImage = imageFruta;
}else if (tenantId == "barto") {
    bgLoginImage = imageBarto;
}else if (tenantId == "circus") {
    bgLoginImage = imageCircus;
}else if (tenantId == "fendy") {
    bgLoginImage = imageFendy;
}else if (tenantId == "cruz") {
    bgLoginImage = imageCruz;
}



export default bgLoginImage;


// WEBPACK FOOTER //
// ./src/screens/login/LoginImageSelector.js